import styled from 'styled-components';
/* background-image: ${({ theme }) => theme.expense.types.active.background};
 */interface Props {
  isActive: boolean;
  userColor: string;
}

export const TypesList = styled.ul`
  display: flex;
  @media (max-width: 359px) {
    flex-wrap: wrap;
  }
`;

export const Type: any = styled.li<Props>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 80px;
  border-radius: 8px;
  margin: 0 5px 16px 0;
  cursor: pointer;
  border: solid 1px ${({ theme }) => theme.expense.types.division};
  background-color: ${({ theme }) => theme.expense.types.background};

  &:last-child {
    margin-bottom: 0;
  }

  &.active {    
    background-color: ${(props) => (props.userColor ? props.userColor : '#666')};
    & > span {
      color: ${({ theme }) => theme.expense.types.active.label};
    }
  }

  @media (max-width: 359px) {
    width: 80px;
  }
`;

Type.Icon = styled.img<Props>`
  height: 24px;
  width: 24px;
  filter: ${(props) => props.isActive && 'brightness(0) invert(1)'};
`;

Type.Label = styled.span`
  font-size: 10px;
  color: ${({ theme }) => theme.expense.types.label};
  text-align: center;
`;
